import { collection, getDocs, limit, query, where } from "firebase/firestore";
import { db } from "../../Firebase/Firebase.utils";
import { slugify } from "./slugify";

async function slugTakenBy(collectionName, slug) {
  const q = query(
    collection(db, collectionName),
    where("slug", "==", slug),
    limit(1)
  );
  const snap = await getDocs(q);
  if (snap.empty) return null;
  return snap.docs[0].id;
}

export async function resolveUniqueSlug({
  collectionName,
  desiredSlug,
  fallbackTitle,
  ignoreId,
}) {
  let base = slugify(desiredSlug || fallbackTitle || "");
  if (!base) base = "untitled";
  let candidate = base;
  let n = 2;
  while (true) {
    const ownerId = await slugTakenBy(collectionName, candidate);
    if (!ownerId || ownerId === ignoreId) return candidate;
    candidate = `${base}-${n}`;
    n += 1;
    if (n > 50) return `${base}-${Date.now()}`;
  }
}
